const TipoDichiarazione = {
  // / <summary>
  // /     Ordinaria
  // / </summary>
  Ordinaria: 0,

  // / <summary>
  // /     Correttiva nei termini
  // / </summary>
  CorrettivaNeiTermini: 1,

  // / <summary>
  // /     Integrativa a favore
  // / </summary>
  IntegrativaFavore: 2,

  // / <summary>
  // /     Integrativa normale
  // / </summary>
  Integrativa: 3,

  // / <summary>
  // /     Tardiva
  // / </summary>
  Tardiva: 4,

  // / <summary>
  // /     Omessa
  // / </summary>
  Omessa: 5,

  // / <summary>
  // /     Annullata (CU 770 MCP)
  // / </summary>
  Annullata: 6,

  // / <summary>
  // /     Sostitutiva (CU 770 MCP)
  // / </summary>
  Sostitutiva: 7,

  // / <summary>
  // /     Integrativa Articolo 2 comma 8-ter
  // / </summary>
  IntegrativaArt2Co8Ter: 8,

  // / <summary>
  // /     Ordinaria liquidazione
  // / </summary>
  OrdinariaLiquidazione: 9,

  // / <summary>
  // /     Correttiva integrativa parziale
  // / </summary>
  CorrettivaIntegrativaParziale: 10,

  // / <summary>
  // /     Simulata
  // / </summary>
  Simulata: 11,

  // / <summary>
  // /     Integrativa art. 1 comma 634-636 L. 190/2014
  // / </summary>
  IntegrativaArt1Co634: 12,

  // / <summary>
  // /     Dichiarazione sostitutiva con nuova trascrizione dei dati e voltura
  // / </summary>
  SostitutivaConNuovaTrascrizioneEVoltura: 13,

  // / <summary>
  // /     Dichiarazione sostitutiva senza una nuova trascrizione dei dati e voltura
  // / </summary>
  SostitutivaSenzaNuovaTrascrizioneEVoltura: 14,

  // / <summary>
  // /     Dichiarazione sostitutiva dei soli allegati
  // / </summary>
  SostitutivaSoliAllegati: 15,
  // / <summary>
  // / Il codice 1 Integrazione della dichiarazione con riferimento esclusivamente ai dati minor debito maggior credito
  // / </summary>
  SetteTrentaIntegrativaCodice1: 16,
  // / <summary>
  // / Il codice 2 Integrazione della dichiarazione con riferimento esclusivamente ai dati del sostituto d’imposta
  // / </summary>
  SetteTrentaIntegrativaCodice2: 17,
  // / <summary>
  // / Il codice 3 Integrazione della dichiarazione con riferimento sia ai dati del sostituto d’imposta sia ad altri dati della dichiarazione da cui scaturiscono un maggior importo a credito, un minor debito oppure un’imposta invariata
  // / </summary>
  SetteTrentaIntegrativaCodice3: 18,

  Variazione: 19,

  /// <summary>
  /// Dichiarazione di successione cartacea, prima dichiarazione
  /// </summary>
  SuccessioniCartaceaPrimaDichiarazione: 32,

  /// <summary>
  /// Dichiarazione di successione cartacea, modificativa
  /// </summary>
  SuccessioniCartaceaModificativa: 33,

  /// <summary>
  /// Dichiarazione di successione cartacea, integrativa
  /// </summary>
  SuccessioniCartaceaIntegrativa: 34,

  /// <summary>
  /// Dichiarazione di successione cartacea, sostitutiva
  /// </summary>
  SuccessioniCartaceaSostitutiva: 35,

  /// <summary>
  /// Dichiarazione di successione cartacea, aggiuntiva
  /// </summary>
  SuccessioniCartaceaAggiuntiva: 36,
};

const toString = (tipo) => {
  switch (tipo) {
    case TipoDichiarazione.Ordinaria:
      return 'Ordinaria';
    case TipoDichiarazione.CorrettivaNeiTermini:
      return 'Correttiva nei termini';
    case TipoDichiarazione.IntegrativaFavore:
      return 'Integrativa a favore';
    case TipoDichiarazione.Integrativa:
      return 'Integrativa';
    case TipoDichiarazione.Tardiva:
      return 'Tardiva';
    case TipoDichiarazione.Omessa:
      return 'Omessa';
    case TipoDichiarazione.Annullata:
      return 'Annullata';
    case TipoDichiarazione.Sostitutiva:
      return 'Sostitutiva';
    case TipoDichiarazione.IntegrativaArt2Co8Ter:
      return 'Integrativa Art2 Co8Ter';
    case TipoDichiarazione.OrdinariaLiquidazione:
      return 'Ordinaria Liquidazione';
    case TipoDichiarazione.CorrettivaIntegrativaParziale:
      return 'Correttiva Integrativa Parziale';
    case TipoDichiarazione.Simulata:
      return 'Simulata';
    case TipoDichiarazione.IntegrativaArt1Co634:
      return 'Integrativa Art1 Co634';
    case TipoDichiarazione.SostitutivaConNuovaTrascrizioneEVoltura:
      return 'Sostitutiva con nuova trascrizione e voltura';
    case TipoDichiarazione.SostitutivaSenzaNuovaTrascrizioneEVoltura:
      return 'Sostitutiva senza nuova trascrizione e voltura';
    case TipoDichiarazione.SostitutivaSoliAllegati:
      return 'Sostitutiva soli allegati';
    case TipoDichiarazione.SetteTrentaIntegrativaCodice1:
      return '730 integrativa codice 1';
    case TipoDichiarazione.SetteTrentaIntegrativaCodice2:
      return '730 integrativa codice 2';
    case TipoDichiarazione.SetteTrentaIntegrativaCodice3:
      return '730 integrativa codice 3';
    case TipoDichiarazione.Variazione:
      return 'Variazione';
    case TipoDichiarazione.SuccessioniCartaceaPrimaDichiarazione:
      return 'Cartacea Modello 4, prima dichiarazione';
    case TipoDichiarazione.SuccessioniCartaceaModificativa:
      return 'Cartacea Modello 4, modificativa';
    case TipoDichiarazione.SuccessioniCartaceaIntegrativa:
      return 'Cartacea Modello 4, integrativa';
    case TipoDichiarazione.SuccessioniCartaceaSostitutiva:
      return 'Cartacea Modello 4, sostitutiva';
    case TipoDichiarazione.SuccessioniCartaceaAggiuntiva:
      return 'Cartacea Modello 4, aggiuntiva';
    default:
      return '';
  }
};

TipoDichiarazione.stringify = toString;

export default TipoDichiarazione;
